import type { ReactNode } from "react";
import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";

const Wrap = styled.section`
  padding: ${spacing.x2}px;
  background-color: ${colors.backgroundLight};
  border-radius: ${borderRadius.regular}px;
`;

const SectionTitle = styled.h2`
  margin: 0 0 ${spacing.x2}px 0;
  font-size: 11px;
  font-weight: 600;
  color: ${colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

type FormSectionProps = {
  title: string;
  children?: ReactNode;
};

export const FormSection = ({ title, children }: FormSectionProps) => {
  return (
    <Wrap>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </Wrap>
  );
};
